export default {"src":"/_next/static/media/beetx-thinking.c4f7934e.svg","height":72,"width":72};